import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import SelectComponent from 'react-select';

const Select = forwardRef(({ getInputValue, backgroundColor = '#F4F6FA', border = '0px', ...props }, ref) => {
    const selectRef = useRef();

    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            minWidth: '150px',
            backgroundColor: backgroundColor,
            border,
            color: '#4C4C66',
            boxShadow: state.isFocused ? 'none' : 'none',
            borderRadius: '10px',
            '&:hover': {
                borderColor: '#000'
            }
        }),
        singleValue: (provided, state) => ({
            ...provided,
            maxWidth: '150px',  // Limit the width of the selected value
            whiteSpace: 'nowrap',  // Prevent text from wrapping
            overflow: 'hidden',  // Hide overflowed text
            textOverflow: 'ellipsis',  // Show ellipsis when text overflows
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? 'blue' : state.isFocused ? '#f0f0f0' : backgroundColor,
            color: state.isSelected ? '#fff' : '#4C4C66',
            // No maxWidth here so the full text is shown
            '&:hover': {
                backgroundColor: '#f0f0f0',
                color: '#4C4C66'
            }
        }),
        menu: (provided) => ({
            ...provided,
            zIndex: 9999,
            backgroundColor: backgroundColor,
            color: '#4C4C66'
        }),
        menuPortal: (provided) => ({
            ...provided,
            zIndex: 9999
        }),
        placeholder: (provided) => ({
            ...provided,
            color: '#9ca3af'
        })
    };
    
    

    useImperativeHandle(ref, () => ({
        resetSelect: () => {
            selectRef.current.clearValue();
        }
    }));
    const handleInputChange = (newValue) => {
        const inputValue = newValue.replace(/\W/g, '');
        if (getInputValue) {
            getInputValue(inputValue);
        }
    };

    return (
        <div className={`relative `}>
            {props?.label && (
                <label className="block text-sm text-[#4C4C66] pb-1 pl-2">{props?.label}{props?.required && ' *'}</label>
            )}
            <SelectComponent
                ref={selectRef}
                styles={customStyles}
                classNamePrefix="solyntek-select"
                menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
                menuPosition="fixed"
                onInputChange={handleInputChange}
                {...props}
            />
            {props?.error && (
                <span className={`absolute ${props?.label ? " top-16" : " top-12"} ml-2 text-xs text-[#FF0000] bottom-0`}>
                    * {props?.error}
                </span>
            )}
        </div>
    );
});

export default Select;
